import React from 'react';
import { storiesOf } from '@storybook/react';
import { action } from '@storybook/addon-actions';
import { CustomAlerts } from './CustomAlerts';

storiesOf('Manage Alerts/CustomAlerts', module)
  .add('Loading', () => (
    <CustomAlerts isLoading />
  ))
  .add('View without data', () => (
    <CustomAlerts alerts={[]} />
  ))
  .add('View', () => (
    <CustomAlerts
      alerts={data.alerts}
      getCustomAlerts={action('getCustomAlerts')}
      updateCustomAlert={action('updateCustomAlert')}
      removeCustomAlert={action('removeCustomAlert')}
    />
  ));

const data = {
  alerts: [
    {
      id: 206,
      name: 'motion - docket',
      created: 1532043435,
      last_execute: 1540123200,
      type_label: 'General',
      delivery: '',
      delivery_options: [
        { value: '', label: 'Email' },
        { value: 'rss', label: 'RSS' },
        { value: 'webhook', label: 'Webhook' },
      ],
      notify_interval: '-1',
      notify_interval_options: [
        { value: -1, label: 'Save/Pause' },
        { value: 3600, label: 'Hourly' },
        { value: 86400, label: 'Daily' },
        { value: 604800, label: 'Weekly' },
      ],
      mail_list: ['asasd.asdasd@qwewqe.dvo', 'qwe@asd.zx'],
      customize_access: true,
    },
    {
      id: 208,
      name: 'motion - alert',
      created: 1532043435,
      last_execute: 1540123200,
      type_label: 'General',
      delivery: '',
      delivery_options: [
        { value: '', label: 'Email' },
        { value: 'rss', label: 'RSS' },
        { value: 'webhook', label: 'Webhook' },
      ],
      notify_interval: '86400',
      notify_interval_options: [
        { value: -1, label: 'Save/Pause' },
        { value: 3600, label: 'Hourly' },
        { value: 86400, label: 'Daily' },
        { value: 604800, label: 'Weekly' },
      ],
      mail_list: ['asasd.asdasd@qwewqe.dvo', 'qwe@asd.zx'],
      customize_access: true,
      isUpdating: true,
    },
    {
      id: 207,
      name: 'motion - history',
      created: 1532043435,
      last_execute: 1540123200,
      type_label: 'General',
      delivery: 'rss',
      delivery_options: [
        { value: '', label: 'Email' },
        { value: 'rss', label: 'RSS' },
        { value: 'webhook', label: 'Webhook' },
      ],
      notify_interval: '3600',
      notify_interval_options: [
        { value: -1, label: 'Save/Pause' },
        { value: 3600, label: 'Hourly' },
        { value: 86400, label: 'Daily' },
        { value: 604800, label: 'Weekly' },
      ],
      mail_list: ['asd@qwe.vo'],
      customize_access: false,
      isUpdating: true,
    },
    {
      id: 991,
      name: 'Personal property SOLR alert check',
      created: 1532043435,
      last_execute: 1540123200,
      type_label: 'Assets',
      delivery: '',
      delivery_options: [
        { value: '', label: 'Email' },
        { value: 'rss', label: 'RSS' },
      ],
      notify_interval: '604800',
      notify_interval_options: [
        { value: -1, label: 'Save/Pause' },
        { value: 86400, label: 'Daily' },
        { value: 604800, label: 'Weekly' },
      ],
      mail_list: [],
      customize_access: true,
      resend: true,
    },
    {
      id: 992,
      name: 'News alert SOLR check',
      created: 1532043435,
      last_execute: 1540123200,
      type_label: 'News',
      delivery: 'webhook',
      delivery_options: [
        { value: '', label: 'Email' },
        { value: 'rss', label: 'RSS' },
      ],
      webhook_url: 'http://courtdrive.dev.azk',
      notify_interval: '3600',
      notify_interval_options: [
        { value: -1, label: 'Save/Pause' },
        { value: 3600, label: 'Hourly' },
        { value: 86400, label: 'Daily' },
        { value: 604800, label: 'Weekly' },
      ],
      mail_list: [],
      customize_access: false,
    },
  ],
};



// WEBPACK FOOTER //
// ./src/components/searchAlerts/CustomAlerts/CustomAlerts.stories.jsx